// extracted by mini-css-extract-plugin
export default {"bloko-media-marker":"bloko-media-marker","blokoMediaMarker":"bloko-media-marker"};